export const getDocsPath = (path) => {
    return `https://docs.adadot.com/${path}`;
};

export const docsPathConstants = {
    codeDaysDefinition: "Data/Definitions/Investment/code_days",
    collaborationDaysDefinition: "Data/Definitions/Investment/collaboration_days",
    balanceDaysDefinition: "Data/Definitions/Investment/balance_days",
    deliveryOutputDefinition: "Data/Definitions/DeliveryOutput",
    deliveryThroughputDefinition: "Data/Definitions/DeliveryOutput/throughput",
    deliveryThroughputTicketsDefinition: "Data/Definitions/DeliveryOutput/throughput/#tickets-done",
    deliveryThroughputPRDefinition:
        "Data/Definitions/DeliveryOutput/throughput/#pull-requests-merged",
    deliveryLeadTimeDefinition: "Data/Definitions/DeliveryOutput/lead_time",
    deliveryLeadTimeIssuesDefinition: "Data/Definitions/DeliveryOutput/lead_time/#issues-lead-time",
    deliveryLeadTimePRDefinition:
        "Data/Definitions/DeliveryOutput/lead_time/#pull-requests-lead-time",
    investmentDefinition: "Data/Definitions/Investment/",
    deliverySprintPlanningDefinition: "Data/Definitions/DeliveryEfficacy/sprint_planning_accuracy",
    deliveryReviewingEfficiencyDefinition: "Data/Definitions/DeliveryEfficacy/reviewing_efficiency",
    personalCreditLongHoursDefinition: "Data/Definitions/PersonalCreditCost/long_hours",
    personalCreditOutOfHoursDefinition: "Data/Definitions/PersonalCreditCost/out_of_hours",
    personalCreditFocusDefinition: "Data/Definitions/PersonalCreditCost/available_focus",

    codeCreditMaintainabilityDefinition: "Data/Definitions/CodeCreditCost/maintainability_index/",
    codeCreditSilosDefinition: "Data/Definitions/CodeCreditCost/code_silos",
    codeCreditBacklogDefinition: "Data/Definitions/CodeCreditCost/backlog_size",
    codeCreditBugsBacklogDefinition: "Data/Definitions/CodeCreditCost/bugs_backlog_size",
    codeCreditBugsDetectedDefinition: "Data/Definitions/CodeCreditCost/bugs_detected",
    codeCreditReworkDefinition: "Data/Definitions/CodeCreditCost/rework",
};
